import {
    closePrivacityTerms,
    acceptPrivacityTerms,
    recoveryCart,
    setSpokesman,
    setCompanyName
} from './store/actions/cart'
import moment from 'moment'

export const getPrivacityTerms = (dispatch) => {
    const privacityTermsResponse = localStorage.getItem(
        'cart.privacityTermsResponse'
    )

    if (privacityTermsResponse) {
        const data = JSON.parse(privacityTermsResponse)
        dispatch(acceptPrivacityTerms(data.datetime))
        dispatch(closePrivacityTerms())
    }
}

export const getCart = (dispatch, bank = '') => {
    const cart = localStorage.getItem('cart.products')
    const partial = localStorage.getItem('contract.partial')

    if (partial) {
        const data = JSON.parse(partial)
        localStorage.removeItem('cart.products')
        localStorage.removeItem('contract.partial')
        dispatch(recoveryCart(data.productsError, bank))
        return
    }

    if (cart) {
        const data = JSON.parse(cart)
        const dateNow = moment()
        let storageDate = moment(data.dateTime).add(8, 'h')
        const isAfter = moment(dateNow).isAfter(storageDate)
        if (isAfter) {
            localStorage.removeItem('cart.products')
        } else {
            const products = data.products.map((product) => ({
                ...product,
                upSellFee: [],
                upSellFeeClosed: false
            }))

            dispatch(recoveryCart(products, bank))
        }
    }
}

export const setLocalCompany = (payload) => {
    if (
        window.OnetrustActiveGroups &&
        window.OnetrustActiveGroups.indexOf(',C0003,') > -1
    ) {
        localStorage.setItem(
            'cart.company',
            JSON.stringify({
                company: payload.company,
                dateTime: moment().format()
            })
        )
    }
}

export const getCompany = (dispatch) => {
    const company = localStorage.getItem('cart.company')
    if (company) {
        const data = JSON.parse(company)
        dispatch(setCompanyName(data.company.name))
    }
}

export const checkDateCompany = () => {
    const company = localStorage.getItem('cart.company')

    if (company) {
        const data = JSON.parse(company)

        const dateNow = moment()
        let storageDate = moment(data.dateTime).add(8, 'h')

        const isAfter = moment(dateNow).isAfter(storageDate)

        if (isAfter) {
            localStorage.removeItem('cart.company')
        }
    }
}

export const setLocalSpokesman = (payload) => {
    if (
        window.OnetrustActiveGroups &&
        window.OnetrustActiveGroups.indexOf(',C0003,') > -1
    ) {
        localStorage.setItem(
            'cart.spokesman',
            JSON.stringify({
                spokesman: payload.spokesman,
                dateTime: moment().format()
            })
        )
    }
}

export const getSpokesman = (dispatch) => {
    const spokesman = localStorage.getItem('cart.spokesman')
    if (spokesman) {
        const data = JSON.parse(spokesman)
        dispatch(
            setSpokesman(
                data.spokesman.name,
                data.spokesman.email,
                data.spokesman.phone,
                data.spokesman.documentNumber,
                data.spokesman.birthDate
            )
        )
    }
}

export const checkDateSpokesman = () => {
    const spokesman = localStorage.getItem('cart.spokesman')

    if (spokesman) {
        const data = JSON.parse(spokesman)

        const dateNow = moment()
        let storageDate = moment(data.dateTime).add(8, 'h')

        const isAfter = moment(dateNow).isAfter(storageDate)

        if (isAfter) {
            localStorage.removeItem('cart.spokesman')
        }
    }
}

export const checkDates = () => {
    checkDateCompany()
    checkDateSpokesman()
}

export const setShopBack = () => {
    sessionStorage.setItem('cart.shopback', 1)
}

export const getShopBack = () => {
    return !!parseInt(sessionStorage.getItem('cart.shopback'))
}
